import { toLocalDate } from "../utils/Date";

export default dateData => {
  const date = toLocalDate(dateData);
  return date ? date.toLocaleString() : "";
};
